import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

const cookieDomain = location.hostname === 'localhost' ? 'localhost' : location.hostname;

export const cookieConfig: NgcCookieConsentConfig = {
    theme: 'classic',
    type: 'opt-in',
    position: 'bottom',
    cookie: {
        domain: cookieDomain
    },
    palette: {
        popup: {
            background: '#101010'
        },
        button: { // Style for 'allow'
            background: '#101010',
            border: '#FFFFFF'
        },
        highlight: { // Style for 'decline'
            background: '#101010',
            border: '#FFFFFF'
        }
    },

    layout: 'default-cookie-template',
    layouts: {
        "default-cookie-template": '{{messagelink}}{{compliance}}'
    },
    elements: {
        messagelink: `
        <div style="text-align: right" class="cc-message">
      <span id="cookieconsent:desc" >{{message}}
        <a aria-label="learn more about cookies" tabindex="1" class="cc-link" href="{{cookiePolicyHref}}" target="_blank" rel="noopener">{{cookiePolicyLink}}</a>
      </span></div>
      `,
    },
    content: {
        allow: 'Accept all cookies',
        deny: 'Essential cookies only',
        message: 'We use cookies to ensure the website works properly, detect errors, and to analyze traffic. You can choose to accept all cookies or only those that are necessary for the site to function. For more information, view our ',
        cookiePolicyLink: 'cookie policy',
        cookiePolicyHref: '/page/privacy-policy',
        policy: 'Cookie Policy',
    },
};
